jQuery(function($){

  var $sponsorSlick = $('.sponsor-slick');

  $sponsorSlick.slick({
    infinite: true,
    centerMode: true,
    slidesToShow: 4,
    dots: false,
    speed: 400,
    swipeToSlide: true,
    accessibility: false,
    centerPadding: 0,
    prevArrow: '<span class="slick-prev slick-arrow"><i class="fa fa-angle-left"></i></span>',
    nextArrow: '<span class="slick-next slick-arrow"><i class="fa fa-angle-right"></i></span>',
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  var $partnerSlick = $('.partner-slick');

  $partnerSlick.slick({
    infinite: true,
    centerMode: true,
    slidesToShow: 4,
    dots: false,
    speed: 400,
    swipeToSlide: true,
    accessibility: false,
    centerPadding: 0,
    prevArrow: '<span class="slick-prev slick-arrow"><i class="fa fa-angle-left"></i></span>',
    nextArrow: '<span class="slick-next slick-arrow"><i class="fa fa-angle-right"></i></span>',
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

});



// WEBPACK FOOTER //
// ./scripts/autoload/_slick.js